/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

export const useClickOutside = (setOpenMenu, selectRef) => {
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (selectRef.current && !selectRef.current.contains(event.target)) {
				setOpenMenu(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);
};
